import { Link } from "react-router-dom";
import { VILLA_MODELS } from "@/pages/home/villaModels";

export default function InvestOptions() {
  return (
    <section id="investments" className="relative w-full py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 md:px-8 max-w-7xl mx-auto">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-[0.2em] uppercase text-primary-600">
            <i className="ri-vip-diamond-line"></i> Investment Options
          </span>
          <h2 className="font-heading text-3xl md:text-5xl text-foreground-950 mt-4 leading-tight">
            Choose Your <span className="italic text-primary-700">Own Villa</span>, Starting From{" "}
            <span className="text-accent-600">₹52 Lakhs</span>
          </h2>
          <p className="text-foreground-600 text-sm md:text-base mt-4 leading-relaxed">
            Every villa is fully furnished and professionally managed to generate consistent
            rental income, grow in value, and welcome you whenever you want a private escape.
          </p>
          <Link
            to="/listings"
            className="mt-6 inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full border border-primary-600 text-primary-700 px-5 py-2.5 hover:bg-primary-600 hover:text-background-50 transition-colors"
          >
            Explore All Villa Models
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mt-10 md:mt-14">
          {VILLA_MODELS.map((opt) => (
            <Link
              key={opt.id}
              to={`/villa/${opt.slug}`}
              className="group relative flex flex-col overflow-hidden rounded-2xl bg-background-100 border border-background-200 hover:bg-background-100/80 hover:border-primary-300 transition-all"
            >
              <div className="relative w-full h-44 md:h-48 overflow-hidden">
                <img
                  src={opt.gallery[0]}
                  alt={`${opt.name} ${opt.type} villa`}
                  title={`${opt.name} villa - ${opt.type}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent"></div>
                <span className="absolute bottom-3 right-3 inline-flex items-center gap-1.5 text-[11px] font-semibold whitespace-nowrap rounded-full bg-background-50/90 text-foreground-800 px-3 py-1.5">
                  View Details <i className="ri-arrow-right-line"></i>
                </span>
              </div>

              <div className="flex flex-col flex-1 p-5 md:p-6">
                <div className="flex items-center justify-between">
                  <span className="text-xs font-semibold tracking-wide text-primary-700 bg-primary-100 rounded-full px-3 py-1">
                    {opt.type}
                  </span>
                  <span className="text-[10px] font-bold tracking-[0.18em] uppercase text-accent-700 bg-accent-100 rounded-full px-2.5 py-1">
                    {opt.tag}
                  </span>
                </div>

                <h3 className="font-heading text-xl md:text-2xl text-foreground-950 mt-4">{opt.name}</h3>

                <div className="mt-5">
                  <p className="text-[11px] uppercase tracking-wide text-foreground-600">Starting from</p>
                  <p className="text-2xl md:text-3xl font-extrabold text-primary-700 mt-1">
                    {opt.priceLabel}
                  </p>
                </div>

                <div className="mt-4 rounded-xl bg-background-50 border border-primary-200/70 px-4 py-3">
                  <p className="text-[11px] uppercase tracking-wide text-foreground-600">Est. annual return</p>
                  <p className="text-lg font-bold text-accent-600 mt-0.5">
                    {opt.roi}
                    <span className="text-xs font-semibold text-primary-600 ml-1">per year</span>
                  </p>
                </div>

                <ul className="mt-5 space-y-2.5 flex-1">
                  {opt.features.slice(0, 3).map((f) => (
                    <li key={f} className="flex items-start gap-2 text-sm text-foreground-700">
                      <i className="ri-check-line text-primary-600 mt-0.5"></i>
                      {f}
                    </li>
                  ))}
                </ul>

                <span className="mt-6 inline-flex items-center justify-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-primary-600 text-background-50 px-4 py-2.5 group-hover:bg-primary-700 transition-colors">
                  View Details
                  <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-between gap-4 rounded-2xl bg-primary-700 px-6 py-5 md:px-8">
          <p className="text-background-50 text-sm md:text-base font-medium">
            <i className="ri-award-line text-accent-400 mr-2"></i>
            Limited inventory available — reserve your villa before the next phase.
          </p>
          <a
            href="tel:8088330330"
            className="inline-flex items-center gap-2 text-sm font-semibold whitespace-nowrap rounded-full bg-accent-500 text-background-50 px-5 py-2.5 hover:bg-accent-600 transition-colors"
          >
            <i className="ri-whatsapp-line"></i> Call / WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}